/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_right } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers/index';

import { COPIES, LINKS } from '../../../../constants';

import styles from './styles.module.scss';

export const List = ({ teams, positions, allTeamsView }) => (
    <div className={styles.positionWrapper}>
        {Object.keys(teams).map((team) => (
            <>
                {positions[team]?.length ? (
                    <div key={team} className={styles.teamPositions}>
                        {allTeamsView ? (
                            <Link to={`/${LINKS.TEAMS}/${team}`}>
                                <h2 className={styles.teamTitle}>
                                    {COPIES.teams[team]}{' '}
                                    <span className={styles.teamCounter}>({positions[team]?.length})</span>
                                </h2>
                            </Link>
                        ) : null}

                        <div>
                            {positions[team] &&
                                positions[team].map((positionsInTeam) => (
                                    <Link
                                        key={positionsInTeam.decoded_id}
                                        to={`/${positionsInTeam.decoded_id}`}
                                        className={styles.positionLink}
                                    >
                                        <div className={styles.positionItem}>
                                            <h6 className={styles.positionItemName}>{positionsInTeam.name}</h6>
                                            <div className={styles.positionItemLocation}>
                                                {positionsInTeam?.location?.name}
                                            </div>
                                            <div className={styles.positionItemIcon}>
                                                <Icon size={12} color={grey_900}>
                                                    {l_chevron_right}
                                                </Icon>
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                        </div>
                    </div>
                ) : null}
            </>
        ))}
    </div>
);
